/* eslint prefer-template:  */
/* eslint-disable */
import moment from 'moment';
import download from 'downloadjs';
import common from '../services/common';
import postData from '../services/postData';
import patchData from '../services/patchData';
import fetchData from '../services/fetchData';
import tabButtonConfigFromFile from '../../config/admin/tabButtonData.json';
import axios from '../axios-config';
// import store from '../store/store';

/* eslint no-undef: */
const DevAutoFill = () => ({
  component: import(`@/autofill/${process.env.NODE_ENV}/DevAutoFill.vue`),
});

export const pageMixin = {
  inject: ['$validator'], // Allows this component's validation messages to appear in other components
  data() {
    return {
      collapsed_elements: [], // List of elements marked as not showing (collapsed)
      testData: 'will this be available in rulesMixin.js??? getting ready for pageMixin!',
      polkTab: [],
      newTab: [],
      addTab: [],
      startTime: '',
      policyBindError: {
        Error: [{
          message: '<div class="smaller-font-content d-inline-block my-auto"><strong>Policy Bound:</strong> This policy has been completed and bound. Any attempted changes to this policy will not be saved. Contact your manager if this policy was saved with incorrect information.</div>',
          type: 'warning',
        }, ],
      },
    }
  },
  components: {
    DevAutoFill,
  },
  computed: {
    /**
     * check quote summary panel status and add css to move content to left
     */
    quotePanelStatus() {
      if (this.$store.getters.getQuoteSummaryStatus) {
        return true;
      } else {
        return false;
      }
    },
   continueEnabled() {
      if (this.pageData.continue_buttons[0].status === 'Enabled') {
        return true;
      }
      return false;
    },
  },
  methods: {
    /**
     * validate rc2 response to proceed to checkout page
     */
    isPolicyBound() {
      return (this.pageData.quote_summary && this.pageData.quote_summary.quote_status === 'Bound'); // TODO: Use config values
    },
    validateRc2Response(response) {
      let parser = new DOMParser();
      let xmlResponse = parser.parseFromString(response.data,"text/xml");
      let parentNode = xmlResponse.getElementsByTagName("StatusDesc");
      const rc2Status = parentNode[0].childNodes[0].nodeValue;
      if (rc2Status === "Success") {
        this.$store.dispatch('setRC2HomeError', false);
      }
      if (rc2Status === "Error") {
        this.$store.dispatch('setRC2HomeError', true);
        const errorNode = xmlResponse.getElementsByTagName("ExtendedStatusDesc");
        const rc2StatusError = errorNode[0].childNodes[0].nodeValue;
        this.$store.dispatch('setRC2HomeErrorDesc', rc2StatusError);
        return false;  
      }
      return true;
    
    },
    //Function to handle all RC response XML error
    validateRcXMLResponse(response) {
      console.log('response',response);
      let parser = new DOMParser();
      let xmlResponse = parser.parseFromString(response,"text/xml");
      let parentNode = xmlResponse.getElementsByTagName("StatusDesc");
      console.log('parentNode',parentNode);
      const rcStatus = parentNode[0].childNodes[0].nodeValue;
      if (rcStatus === "Success") {
        console.log('testing  XML success');
        this.$store.dispatch('setRCHomeError', false);
      }
      if (rcStatus === "Error") {
        console.log('testing Rc3 XML error');
        this.$store.dispatch('setRCHomeError', true);
        const errorNode = xmlResponse.getElementsByTagName("MsgStatusDesc");
        const rcStatusError = errorNode[0].childNodes[0].nodeValue;
        this.$store.dispatch('setRCHomeErrorDesc', rcStatusError);
        return false;  
      }
      return true;
    
    },
    /* eslint-disable */
    /**
     * Returns whether there are visible fields within the section
     *
     * @param {*} sectionName 
     * @param {*} fields 
     */
    hasFields(sectionName, fields) {
      return fields.some(field => field.section === sectionName && field.visible);
    },
    /**
     * Returns whether the given ID is in the list of collapsed elements.
     */
    is_showing(el_id) {
      return (this.collapsed_elements.indexOf(el_id) === -1 ? true : false);
    },
    /**
     * Fetches the list of collapsed elements from the session.
     */
    get_collapsed_elements_list: function () {
      const TOGGLE_COLLAPSE = 'toggle_collapse'; // TODO: Use config value

      return JSON.parse(sessionStorage.getItem(TOGGLE_COLLAPSE)) || []; // List of elements marked as showing
    },
    /**
     * Show/hide elements and store their state in the session.
     * 
     * @param {element or string} event - The source that triggered this
     * @param {boolean} from_collapser - Whether the collapser element triggered this (flips target and source)
     */
    toggle_collapse: function (event, from_collapser = false) {
      const TOGGLE_COLLAPSE = 'toggle_collapse', // TODO: Use config value
        target_name = (from_collapser ? event.id : event.currentTarget.dataset.target.substring(1)), // Name of target w/o the '#'
        source_name = (from_collapser ? event.dataset.target.substring(1) : event.currentTarget.id); // ID of element that triggered this

      var i = this.collapsed_elements.indexOf(target_name); // Index of current target, if it exists in the list

      if (i === -1) {
        document.getElementById(target_name).classList.remove('show'); // Toggle whether it shows
        document.getElementById(source_name).classList.remove('active'); // Toggle +/-
        this.collapsed_elements.push(target_name); // Add to list of showing elements
      } else {
        document.getElementById(target_name).classList.add('show'); // Toggle whether it shows
        document.getElementById(source_name).classList.add('active'); // Toggle +/-
        this.collapsed_elements.splice(i, 1); // Remove from list of showing elements
      }

      sessionStorage.setItem(TOGGLE_COLLAPSE, JSON.stringify(this.collapsed_elements)); // Set new list back into session
    },
    reset_toggle_collapse: function () {
      const TOGGLE_COLLAPSE = 'toggle_collapse'; // TODO: Use config value

      this.collapsed_elements = [];
      sessionStorage.setItem(TOGGLE_COLLAPSE, JSON.stringify(this.collapsed_elements)); // Set new list back into session
    },
    getContinueLabelName() {
      if (this.$route.path.includes('rc2-policy-details') && (sessionStorage.getItem('flowType') === 'bundle' || sessionStorage.getItem('flowType') === 'cabundle' || sessionStorage.getItem('flowType') === 'rabundle')) {
        return 'Save & Continue to Checkout';
      }
      return (typeof this.pageData.continue_buttons !== 'undefined' &&
        this.pageData.continue_buttons.length ?
        common.getContinueLabelName(this.pageData.continue_buttons) : '');
    },
    get_first_invalid_element() {
      var first_invalid_element = false;
      if (this.$validator.errors.items.length) {
        // TODO: Go to the field's container rather than to the input element itself
        if (this.$validator.errors.items[0].field === 'QTE_PRP_CreditCardExpirationDate_masked'){
          first_invalid_element = document.getElementById('QTE_PRP_CreditCardExpirationDate_block')
        } else if (this.$validator.errors.items[0].field === 'QTE_CreditCardExpirationDate_masked') {
          first_invalid_element = document.getElementById('QTE_CreditCardExpirationDate_block');
        } else {
          first_invalid_element = document.getElementById(`${this.$validator.errors.items[0].field}_block`);
        }
        if (first_invalid_element.style.display === 'none') {
          first_invalid_element = first_invalid_element.parentElement; // TODO: Check if parent is hidden
        }
      }

      return first_invalid_element;
    },
    setfocusOnFirstError(first_invalid_element) {
      const first_invalid_elementFocus = first_invalid_element['id'].split("_block");
      const first_invalid_elementFocused = first_invalid_elementFocus[0];
      const ref_field_type = this.$refs[first_invalid_elementFocused][0].formdata.field_type
      if (ref_field_type == 'select_large' || ref_field_type == 'select_medium' || ref_field_type == 'select_short') {
        this.$refs[first_invalid_elementFocused][0].$refs[first_invalid_elementFocused].$children[0].$el.focus();
      }
      if (ref_field_type == 'numberterm_miles' || ref_field_type == 'numberterm_days' || ref_field_type == 'money_medium' || ref_field_type == 'number_medium') {
        this.$refs[first_invalid_elementFocused][0].$refs[first_invalid_elementFocused].$children[1].$el.focus();
      }
      if (ref_field_type == 'text_large' || ref_field_type == 'text_long' || ref_field_type == 'text_medium_right' || ref_field_type == 'checkbox' || ref_field_type == 'address_long' || ref_field_type == 'input_integer') {
        this.$refs[first_invalid_elementFocused][0].$refs[first_invalid_elementFocused].$refs[first_invalid_elementFocused].focus()
      }
      if (ref_field_type == 'phonenumber_large' || ref_field_type == 'date_long_pii') {
        this.$refs[first_invalid_elementFocused][0].$refs[first_invalid_elementFocused].$children[1].$el.focus()
      } else {
        this.$refs[first_invalid_elementFocused][0].$refs[first_invalid_elementFocused].$refs[first_invalid_elementFocused][0].focus()
      }
    },
    mainSubmit() {
      if (common.getContinueSubmitStatus(this.pageData.continue_buttons[0].status) !== 'Disabled')
      this.$validator.validateAll().then((result) => {

        let first_invalid_element = this.get_first_invalid_element();
        console.log('trying error elemnt mainsubmit', first_invalid_element);
        if (!result && first_invalid_element) {
          let me = first_invalid_element, // Access the invalid element
            my_parent = me;

          // TODO: This is redundant from field-level method `expose_errors`. Refactor into one.
          // Traverse the DOM upward, looking for collapsed elements
          while ((my_parent = my_parent.parentElement) && my_parent.tagName !== 'FORM') {
            if (my_parent.classList.contains('collapse') && !my_parent.classList.contains('show')) {
              this.toggle_collapse(my_parent, true); // This parent is collapsed, so expand it
            }
          }

          first_invalid_element.scrollIntoView(); // Scroll to the first error

          // this.setfocusOnFirstError(first_invalid_element); Commenting out for now,Need to add later for accessibility.

          window.scrollBy(0, -180); // TODO: Use nav margin + height of #form-headings
          return;
        }
        // submit form 
        const requestParams = {
          url: common.getContinueSubmitUrl(this.pageData.continue_buttons),
          data: common.getFormData(this.pageData),
        };
        this.$store.dispatch('setStartTime');
        this.$store.dispatch('setPageActionName', 'FormSubmit');
        // add current action in session storage to manage quote summary modal behavior
        sessionStorage.setItem('currentActionName', 'FormSubmit');
        let isSubmitFromCheckout = false;
        if ((sessionStorage.getItem('flowType') === 'bundle' || sessionStorage.getItem('flowType') === 'cabundle' || sessionStorage.getItem('flowType') === 'rabundle') && this.$router.currentRoute.path.includes('/checkout')) {  
          requestParams.page_name = sessionStorage.getItem('autoPageName');
          requestParams.session_id = JSON.parse(sessionStorage.getItem('autoSessionData')).SessionId;
          requestParams.payment_session_id = this.$store.getters.getSameHomeBillingInfo ? JSON.parse(sessionStorage.getItem('homeSessionData')).SessionId : '';
          isSubmitFromCheckout = true;
        }
        postData.navigationFormPost(requestParams).then(async (response) => {
          
          let homeRc2Status = false;
          let callHomeRC2 = sessionStorage.getItem('selectedCarrierHome') !== null && JSON.parse(sessionStorage.getItem('selectedCarrierHome')).carrier_type !== 'EZLYNXCARRIER';
          
          if(sessionStorage.getItem('flowType') === 'bundle' && this.$router.currentRoute.path.includes('/rc2-policy-details') && callHomeRC2 && sessionStorage.getItem('homebound') != 'true') {//condition for bind call
            
            let homeRC2Errors = JSON.parse(sessionStorage.getItem('homeRC2Errors'));
            let submitFrom = 'auto';
            let HOQuoteId = JSON.parse(sessionStorage.getItem('homeSessionData')).SessionId;
            homeRc2Status = await this.propertyBindsubmitted(homeRC2Errors, submitFrom, HOQuoteId);
          } else {
            homeRc2Status = true;
          }
          if (response.data.Navigate && homeRc2Status) {
            if ((this.$route.name === 'home/coverages' && sessionStorage.getItem('flowType') === 'bundle') 
            || (this.$route.name === 'condo/coverages' && sessionStorage.getItem('flowType') === 'cabundle') 
            || (this.$route.name === 'renters/coverages' && sessionStorage.getItem('flowType') === 'rabundle')) {
              
              sessionStorage.setItem('rc1NavButton',JSON.stringify(this.$store.getters.buttonsData));
              
              // log API response time through application into GA tool
              common.gapRecordAnalyticsGeneric(this.$store.getters.getStartTime, 'FormSubmitAPI', this.$store.getters.getPageName);
              
              let AUQuoteId = JSON.parse(sessionStorage.getItem('autoSessionData')).SessionId;

              let cuurentNav  = '/pages/namedinsured/' + AUQuoteId;
              this.$store.dispatch('setCurrentNav', cuurentNav);
              let newRoute = "/auto/name-insured";//auto first page
              this.$store.dispatch('setSessionQuote', { SessionId: AUQuoteId });
              //change session data in storage
              sessionStorage.setItem('sessionData', sessionStorage.getItem('autoSessionData'));
              this.$router.push(newRoute);
            } else {
              if(isSubmitFromCheckout) {
                this.$router.replace('/auto/bundle/confirmation');
              } else {
                // log API response time through application into GA tool
                common.gapRecordAnalyticsGeneric(this.$store.getters.getStartTime, 'FormSubmitAPI', this.$store.getters.getPageName);
                this.$store.dispatch('setCurrentNav', response.data.Navigate);
                let newRoute = common.getRouteName(response.data.Navigate);
                if ((sessionStorage.getItem('flowType') === 'bundle' || sessionStorage.getItem('flowType') === 'cabundle' || sessionStorage.getItem('flowType') === 'rabundle') && this.$router.currentRoute.path.includes('/rc2-policy-details')) {
                  sessionStorage.setItem('checkoutNav', response.data.Navigate);
                }
                let curRoute = this.$router.currentRoute.path;
                if (curRoute.includes(newRoute)) {
                  let timeStamp = new Date().getTime();
                  this.$router.push({
                    path: newRoute + '?' + timeStamp
                  })
                } else {
                  this.$router.replace(newRoute);
                }
              }
            }
          }
          // this.pageData = response.data;
        });
      }).catch((err) => {});
    },

    validateVgs(vgsForm) {
      let vgsState = vgsForm.state;
      let areVgsFieldsValid = true;
      let invalids = [];
      // Creates list of only active fields (i.e., only credit card, credit card and bank account installment, etc)
      for (let key in vgsState) {
        if (vgsState[key].isValid === false) {
          areVgsFieldsValid = false;
          invalids.push(key);
        };
      }

      return {
        isValid: areVgsFieldsValid,
        invalids,
      }
    },
    vgsSubmitProperty() {
      let vgsCardType= [];
      let typeCnt = 0;
     const vgsStateData = this.vgsForm.state;
      const sortedVgsState = Object.keys(vgsStateData).sort().reduce((accumulator, currentValue) => {
        accumulator[currentValue] = vgsStateData[currentValue];
        return accumulator;
      }, {});
      this.$store.commit('setVgsIndexes', this.currentPaymentFieldsOrder);
      
      for (let objVgs in sortedVgsState) {
        if (sortedVgsState[objVgs] && sortedVgsState[objVgs].cardType) {
          vgsCardType.push(sortedVgsState[objVgs].cardType);    
        }
       
      }
      for (let pCnt = 0; pCnt < this.pageData.fields.length; pCnt += 1) {
        if (this.pageData.fields[pCnt].visible && this.pageData.fields[pCnt].field_type === 'select_CCType') {
          for (let ctCnt = 0; ctCnt < vgsCardType.length; ctCnt += 1) {
            this.pageData.fields[pCnt].field_value = vgsCardType[typeCnt];
            typeCnt++; 
            break;
          }
        }
      }
      this.$validator.validateAll().then((result) => {
        let first_invalid_element = this.get_first_invalid_element() || null;
       let vgsValidationResults = this.validateVgs(this.vgsForm) || null;
       // when invalid don't continue with submit form
        if (!result && first_invalid_element || !vgsValidationResults.isValid) {
          let me = first_invalid_element, // Access the invalid element
          my_parent = me;

          // TODO: This is redundant from field-level method `expose_errors`. Refactor into one.
          // Traverse the DOM upward, looking for collapsed elements
          while ((my_parent = my_parent.parentElement) && my_parent.tagName !== 'FORM') {
            if (my_parent.classList.contains('collapse') && !my_parent.classList.contains('show')) {
              this.toggle_collapse(my_parent, true); // This parent is collapsed, so expand it
            }
          }

          if (first_invalid_element) {
            first_invalid_element.scrollIntoView(); // Scroll to the first error
            // this.setfocusOnFirstError(first_invalid_element); Commenting out for now,Need to add later for accessibility.
          } else {
            window.scrollBy(0, -980); // Scroll to top.
          }

          // return early without continuing with POST
          return;
        }
       // submit form vgsprop //temporary
       let requestParams = {
          url: `quotes/${this.$store.getters.getSessionID}/rc3`,
          data: common.getFormData(this.pageData),
        };
        const vgsFormObj = this.vgsForm;
        this.$store.dispatch('setStartTime');
        this.$store.dispatch('setPageActionName', 'FormSubmit');
        
        postData.vgsNavigationFormPost(requestParams, vgsFormObj, 'home').then((response) => {
          if (response) {
            // log API response time through application into GA tool
            common.gapRecordAnalyticsGeneric(this.$store.getters.getStartTime, 'FormSubmitAPI', this.$store.getters.getPageName);
            if (this.validateRcXMLResponse(response)) {
                // do all success stuff here
                this.$store.dispatch('sethomeRc2Nav', 'hoconfirmation');
                let curRoute = this.$router.currentRoute.path;
               
                if (curRoute.includes('hoconfirmation')) {
                  let timeStamp = new Date().getTime();
                  this.$router.push({
                    path: 'confirmation' + '?' + timeStamp
                  })
                } else {
                 // this.$router.replace(newRoute);
                  this.$router.replace(common.getRouteName(`/Property/hoconfirmation/tp`));
                }
              } else {
                return false;
                // do all fail stuff here 
              }
         
          }
           // set VGS/RC3 error status to default 
          this.$store.dispatch('setRCHomeError', false);
          this.$store.dispatch('setRCHomeErrorDesc', "");
          vgsCardType= [];
          this.pageData = response.data;
       });
      }).catch((err) => {
        console.log(err);
      });
    },
    /**
     * THis function is used to submit Home policy from bundle flow
     * Created new function as having different object for page data as homePageData
     * TODO: check if it can be generic code
     */
    vgsBundleSubmitProperty() {
      let HOQuoteId = JSON.parse(sessionStorage.getItem('homeSessionData')).SessionId;
      let vgsCardType = [];
      let typeCnt = 0;
      console.log('vgsStateData==',this.pageData);
      const vgsStateData = this.homeVgsForm.state;
      const sortedVgsState = Object.keys(vgsStateData).sort().reduce((accumulator, currentValue) => {
        accumulator[currentValue] = vgsStateData[currentValue];
        return accumulator;
      }, {});
      // console.log('homeCurrentPaymentFieldsOrder=======', this.homeCurrentPaymentFieldsOrder);
      this.$store.commit('setHomeVgsIndexes', this.homeCurrentPaymentFieldsOrder);

      for (let objVgs in sortedVgsState) {
        if (sortedVgsState[objVgs] && sortedVgsState[objVgs].cardType) {
          vgsCardType.push(sortedVgsState[objVgs].cardType);
        }

      }
      for (let pCnt = 0; pCnt < this.homePageData.fields.length; pCnt += 1) {
        if (this.homePageData.fields[pCnt].visible && this.homePageData.fields[pCnt].field_type === 'select_CCType') {
          for (let ctCnt = 0; ctCnt < vgsCardType.length; ctCnt += 1) {
            this.homePageData.fields[pCnt].field_value = vgsCardType[typeCnt];
            typeCnt++;
            break;
          }
        }
      }
      this.$validator.validateAll().then((result) => {
        let first_invalid_element = this.get_first_invalid_element() || null;
        let vgsValidationResults = this.validateVgs(this.homeVgsForm) || null;
        // when invalid don't continue with submit form
        if (!result && first_invalid_element || !vgsValidationResults.isValid) {
          let me = first_invalid_element, // Access the invalid element
            my_parent = me;

          // TODO: This is redundant from field-level method `expose_errors`. Refactor into one.
          // Traverse the DOM upward, looking for collapsed elements
          // while ((my_parent = my_parent.parentElement) && my_parent.tagName !== 'FORM') {
          //   if (my_parent.classList.contains('collapse') && !my_parent.classList.contains('show')) {
          //     this.toggle_collapse(my_parent, true); // This parent is collapsed, so expand it
          //   }
          // }

          if (first_invalid_element) {
            let toggle_div = first_invalid_element.closest('.collapse')
            if(!toggle_div.classList.contains('show')){
              toggle_div.classList.add("show");
              toggle_div.setAttribute("style", "block");
            }            
            first_invalid_element.scrollIntoView();
            window.scrollBy(0, -180);
            // Scroll to the first error
            // this.setfocusOnFirstError(first_invalid_element); Commenting out for now,Need to add later for accessibility.
          } else {
            window.scrollBy(0, -980); // Scroll to top.
          }

          // return early without continuing with POST
          return;
        }
        for (let pCnt = 0; pCnt < this.homePageData.fields.length; pCnt += 1) {
          if (this.homePageData.fields[pCnt].visible && this.homeAckFields.includes(this.homePageData.fields[pCnt].field_name) && this.homePageData.fields[pCnt].field_value === 'N') {
            return;
          }
        }
        if ((sessionStorage.getItem('selectedCarrierAuto') != null && this.$store.getters.getAutoRC2Status === 'success' && !this.$store.getters.getAutoLinkButtunStatus) && !(this.$store.getters.getAutoBindStatus && this.$store.getters.getAutoBindStatus.Status === 'Success')) {
          for (let pCnt = 0; pCnt < this.pageData.fields.length; pCnt += 1) {
            if (this.pageData.fields[pCnt].visible && this.autoAckFields.includes(this.pageData.fields[pCnt].field_name) && this.pageData.fields[pCnt].field_value === 'N') {
              return;
            }
          }
        }
        // submit form vgsprop //temporary
        let requestParams = {
          url: `quotes/${HOQuoteId}/rc3`,
          data: common.getFormData(this.homePageData),
        };
        // console.log(this.homePageData,'data===', requestParams);return;
        const vgsFormObj = this.homeVgsForm;
        this.$store.dispatch('setStartTime');
        this.$store.dispatch('setPageActionName', 'FormSubmit');

        postData.vgsNavigationFormPost(requestParams, vgsFormObj, 'bundle').then((response) => {
          if (response) {
            common.gapRecordAnalyticsGeneric(this.$store.getters.getStartTime, 'FormSubmitAPI', this.$store.getters.getPageName);
            this.$store.dispatch('sethomeRc2Nav', 'hoconfirmation');
            if ((sessionStorage.getItem('selectedCarrierAuto') != null && this.$store.getters.getAutoRC2Status === 'success' && !this.$store.getters.getAutoLinkButtunStatus) && !(this.$store.getters.getAutoBindStatus && this.$store.getters.getAutoBindStatus.Status === 'Success')) {
              if (this.$store.getters.getSameHomeBillingInfo) {
                this.mainSubmit();
              } else {
                //call auto bind call
                this.vgsSubmit();
              }
            } else {
              this.$router.replace('/auto/bundle/confirmation');//TODO:route to bundle confirmation
            }
          }
          // set VGS/RC3 error status to default 
          this.$store.dispatch('setRCHomeError', false);
          this.$store.dispatch('setRCHomeErrorDesc', "");
          vgsCardType = [];
          this.homePageData = response.data;
        });
      }).catch((err) => {
        console.log(err);
      });
    },
    vgsSubmit() {
      let vgsCardType= [];
      let typeCnt = 0;
      const vgsStateData = this.vgsForm.state;
      const sortedVgsState = Object.keys(vgsStateData).sort().reduce((accumulator, currentValue) => {
        accumulator[currentValue] = vgsStateData[currentValue];
        return accumulator;
      }, {});
      this.$store.commit('setVgsIndexes', this.currentPaymentFieldsOrder);
      
      for (let objVgs in sortedVgsState) {
        if (sortedVgsState[objVgs] && sortedVgsState[objVgs].cardType) {
          vgsCardType.push(sortedVgsState[objVgs].cardType);    
        }
       
      }
      for (let pCnt = 0; pCnt < this.pageData.fields.length; pCnt += 1) {
        if (this.pageData.fields[pCnt].visible && this.pageData.fields[pCnt].field_type === 'select_CCType') {
          for (let ctCnt = 0; ctCnt < vgsCardType.length; ctCnt += 1) {
            this.pageData.fields[pCnt].field_value = vgsCardType[typeCnt];
            typeCnt++; 
            break;
          }
        }
      }
      if (common.getContinueSubmitStatus(this.pageData.continue_buttons[0].status) !== 'Disabled')
      this.$validator.validateAll().then((result) => {
        let first_invalid_element = this.get_first_invalid_element() || null;
        let vgsValidationResults = this.validateVgs(this.vgsForm) || null;

        // when invalid don't continue with submit form
        if (!result && first_invalid_element || !vgsValidationResults.isValid) {
          let me = first_invalid_element, // Access the invalid element
          my_parent = me;
          if (sessionStorage.getItem('flowType') === 'bundle' || sessionStorage.getItem('flowType') === 'cabundle' || sessionStorage.getItem('flowType') === 'rabundle') {
            if (first_invalid_element) {
              let toggle_div = first_invalid_element.closest('.collapse')
              if(!toggle_div.classList.contains('show')){
                toggle_div.classList.add("show");
                toggle_div.setAttribute("style", "block");
              }            
              first_invalid_element.scrollIntoView();
              window.scrollBy(0, -180);
            } else {
              window.scrollBy(0, -980); // Scroll to top.
            }
          } else {
            // TODO: This is redundant from field-level method `expose_errors`. Refactor into one.
            // Traverse the DOM upward, looking for collapsed elements
            while ((my_parent = my_parent.parentElement) && my_parent.tagName !== 'FORM') {
              if (my_parent.classList.contains('collapse') && !my_parent.classList.contains('show')) {
                this.toggle_collapse(my_parent, true); // This parent is collapsed, so expand it
              }
            }
            if (first_invalid_element) {
              first_invalid_element.scrollIntoView(); // Scroll to the first error
              // this.setfocusOnFirstError(first_invalid_element); Commenting out for now,Need to add later for accessibility.
            } else {
              window.scrollBy(0, -980); // Scroll to top.
            }
          }
          // return early without continuing with POST
          return;
        }
        
        if ((sessionStorage.getItem('flowType') === 'bundle' || sessionStorage.getItem('flowType') === 'cabundle' || sessionStorage.getItem('flowType') === 'rabundle') && (sessionStorage.getItem('selectedCarrierAuto') != null && this.$store.getters.getAutoRC2Status === 'success') && !(this.$store.getters.getAutoBindStatus && this.$store.getters.getAutoBindStatus.Status === 'Success')) {
          for (let pCnt = 0; pCnt < this.pageData.fields.length; pCnt += 1) {
            if (this.pageData.fields[pCnt].visible && this.autoAckFields.includes(this.pageData.fields[pCnt].field_name) && this.pageData.fields[pCnt].field_value === 'N') {
              return;
            }
          }
        }
        // submit form 
        const requestParams = {
          url: `${common.getContinueSubmitUrl(this.pageData.continue_buttons)}`,
          data: common.getFormData(this.pageData),
        };
        const vgsFormObj = this.vgsForm;
        this.$store.dispatch('setStartTime');
        this.$store.dispatch('setPageActionName', 'FormSubmit');

        postData.vgsNavigationFormPost(requestParams, vgsFormObj, 'auto').then((response) => {
          if (sessionStorage.getItem('flowType') === 'bundle' || sessionStorage.getItem('flowType') === 'cabundle' || sessionStorage.getItem('flowType') === 'rabundle') {
            // let carrierCode = sessionStorage.getItem('autoPageName').substring(0, 4);//TODO: check if its working for each carrier

            // let AUQuoteId = JSON.parse(sessionStorage.getItem('autoSessionData')).SessionId;
            // let cuurentNav  = `/pages/${carrierCode}Confirmation/${AUQuoteId}`;
            // this.$store.dispatch('setCurrentNav', cuurentNav);
            // sessionStorage.removeItem('homePageName');
            // sessionStorage.removeItem('autoPageName');
            this.$router.replace('/auto/bundle/confirmation');
          } else {
            if (response.Navigate) {
              // log API response time through application into GA tool
              common.gapRecordAnalyticsGeneric(this.$store.getters.getStartTime, 'FormSubmitAPI', this.$store.getters.getPageName);

              this.$store.dispatch('setCurrentNav', response.Navigate);
              let newRoute = common.getRouteName(response.Navigate);
              let curRoute = this.$router.currentRoute.path;
              if (curRoute.includes(newRoute)) {
                let timeStamp = new Date().getTime();
                this.$router.push({
                  path: newRoute + '?' + timeStamp
                })
              } else {
                this.$router.replace(newRoute);
              }
            }
          }
          vgsCardType= [];
          // this.pageData = response.data;
        });
      }).catch((err) => {
        console.log(err);
      });
    },
    /*starting rc2 home submit code*/
    propertyRc2submitted() {
      /**
       * check for api errors
       */
      let nav = this.$store.getters.rc2Navigation;
      const navsArr = nav.navs;
      let pageNoError = true;
      let apiErrors = false;
      let jsErrors = false;
      let pageSectionApiError;
      let pageSectionjsErrors;
      for (let eCnt = 0; eCnt < this.pageData.fields.length; eCnt++) {
        if (this.pageData.fields[eCnt].visible && this.pageData.fields[eCnt].has_error) {
          pageSectionApiError = this.pageData.fields[eCnt].section;
          apiErrors = true;
        }
        if (this.pageData.fields[eCnt].visible && this.pageData.fields[eCnt].is_required && this.pageData.fields[eCnt].field_value === '') {
          pageSectionjsErrors = this.pageData.fields[eCnt].section;
          jsErrors = true;
        }
      }
      this.setPolicyStatus(this.pageData);
      const getUrl = `/pages/HORateCall2Details/${this.$store.getters.getSessionID}`;
      // const continueButtonRouteTo = this.$store.getters.continueButtonData[0].routeTo;
      // const continueButtonRouteLabel = this.$store.getters.continueButtonData[0].label;
      // console.log(!apiErrors, this.$validator, 'continueButtonRouteTo status ',common.getContinueSubmitStatus(this.pageData.continue_buttons[0].status));
      // if (common.getContinueSubmitStatus(this.pageData.continue_buttons[0].status) !== 'Disabled')
      this.$validator.validateAll().then((result) => {
        let first_invalid_element = this.get_first_invalid_element();
        if (!result && first_invalid_element) {
          let me = first_invalid_element, // Access the invalid element
            my_parent = me;
          // TODO: This is redundant from field-level method `expose_errors`. Refactor into one.
          // Traverse the DOM upward, looking for collapsed elements
          while ((my_parent = my_parent.parentElement) && my_parent.tagName !== 'FORM') {
            if (my_parent.classList.contains('collapse') && !my_parent.classList.contains('show')) {
              this.toggle_collapse(my_parent, true); // This parent is collapsed, so expand it
            }
          }
          first_invalid_element.scrollIntoView(); // Scroll to the first error
          // this.setfocusOnFirstError(first_invalid_element); Commenting out for now,Need to add later for accessibility.
          window.scrollBy(0, -180); // TODO: Use nav margin + height of #form-headings
          return;
        }
        //   return false;
        if (apiErrors) {
          let filterPageSection = navsArr.filter(el => el.sections.includes(pageSectionApiError));
          if (this.pageData.continue_buttons[0].pageName === filterPageSection[0].page_name)
            return;
        }
        // submit form 
        const requestParams = {
          url: getUrl,
          data: common.getFormData(this.pageData),
        };
        this.$store.dispatch('setStartTime');
        this.$store.dispatch('setPageActionName', 'FormSubmit');
        // console.log("continueButtonRouteLabelcontinueButtonRouteLabel", continueButtonRouteLabel);
        console.log("currentformsubmitpage", sessionStorage.getItem("sethomeRc2Nav"));
        patchData.navigationFormPatch(requestParams).then((response) => {
          // log API response time through application into GA tool
          common.gapRecordAnalyticsGeneric(this.$store.getters.getStartTime, 'FormSubmitAPI', this.$store.getters.getPageName);
          // const carData = JSON.parse(sessionStorage.getItem("selectedCarrierHome"));
          let homeRC2Errors = {
            'apiErrors': apiErrors,
            'jsErrors': jsErrors,
            'navsArr': navsArr,
            'pageSectionjsErrors': pageSectionjsErrors,
            'pageSectionApiError': pageSectionApiError,
          } 
          //Navigate bundle to auto
          if (((this.pageData.page_name.includes("bran") && this.$route.name === 'home/policydetails') || (!this.pageData.page_name.includes("bran") && this.$route.name === 'home/coverage')) && this.flowType === 'bundle' && (this.$store.getters.getSelectedAutoCarrier !== null && sessionStorage.getItem('selectedCarrierAuto') !== null)) {
            sessionStorage.setItem('homeRC2pagename', this.pageData.page_name);
            let autoCarrierType = this.$store.getters.getSelectedAutoCarrier != '' && this.$store.getters.getSelectedAutoCarrier !== null ? this.$store.getters.getSelectedAutoCarrier.carrier_type : sessionStorage.getItem('selectedCarrierAuto') ? JSON.parse(sessionStorage.getItem('selectedCarrierAuto')).carrier_type : '';
            //TODO checking from session storage as home coverage is getting reload and store is getting clear
            sessionStorage.setItem('continueButtonData', JSON.stringify(this.$store.getters.continueButtonData));
            sessionStorage.setItem('homeRC2Errors', JSON.stringify(homeRC2Errors));
            if (autoCarrierType === 'EZLYNXCARRIER') {
                sessionStorage.setItem('sessionData', sessionStorage.getItem('autoSessionData')); 
                this.$store.dispatch('setSessionQuote', { SessionId: JSON.parse(sessionStorage.getItem('autoSessionData')).SessionId });
                this.$router.replace('/auto/non-end-to-end');
            } else {
              let AUQuoteId = JSON.parse(sessionStorage.getItem('autoSessionData')).SessionId;
              let currentNav = JSON.parse(sessionStorage.getItem('autoRC1BindResponse')).Navigate;
              this.$store.dispatch('setCurrentNav', currentNav);
              this.$store.dispatch('setSessionQuote', { SessionId: AUQuoteId });
              //change session data in storage
              sessionStorage.setItem('sessionData', sessionStorage.getItem('autoSessionData'));            
              this.$router.replace(common.getRouteName(currentNav));
            }
          } else {
            //submitFrom changed from home to auto as in case of single home carrier need to redirect to bundle checkout
            let submitFrom = this.flowType === 'bundle' ? 'bundle' : 'home';

            this.propertyBindsubmitted(homeRC2Errors, submitFrom, this.$store.getters.getSessionID);
          }
        });
      }).catch((err) => { });
    },
    async propertyBindsubmitted(homeRC2Errors, submitFrom, sessionID) {
      let finalresponseStatus = false;
      const carData = JSON.parse(sessionStorage.getItem("selectedCarrierHome"));

      let continueButtonRouteTo;
      let continueButtonRouteLabel;
      let page_name = typeof this.pageData.page_name !== 'undefined' ? this.pageData.page_name : sessionStorage.getItem('homeRC2pagename');      
      if (this.$store.getters.continueButtonData.length === 0 && submitFrom !== 'home') {
        let continueButtonData = JSON.parse(sessionStorage.getItem("continueButtonData"));
        continueButtonRouteTo = continueButtonData[0].routeTo;
        continueButtonRouteLabel = continueButtonData[0].label;
      } else {        
        continueButtonRouteTo = this.$store.getters.continueButtonData[0].routeTo;
        continueButtonRouteLabel = this.$store.getters.continueButtonData[0].label;
      }

      let finalNavData = this.$store.getters.finalNavData;
      if(finalNavData.length === 0 && submitFrom !== 'home') {
        finalNavData = JSON.parse(sessionStorage.getItem("setfinalNavDataAction"));
      }
      let routeToErrorPage;      
      let apiErrors = homeRC2Errors.apiErrors;
      let jsErrors = homeRC2Errors.jsErrors;
      let navsArr = homeRC2Errors.navsArr;
      let pageSectionjsErrors = homeRC2Errors.pageSectionjsErrors;
      let pageSectionApiError = homeRC2Errors.pageSectionApiError;
      // let sessionID = this.$store.getters.getSessionID;

      const getUrl = `/pages/HORateCall2Details/${sessionID}`;
      let pageNoError = true;
      if (page_name.includes("bran") && continueButtonRouteLabel.includes("to Policy")) {
        //Branch specific code
        /* start for patch call for carrier*/
        let requestParams = {
          url: `/quotes/${sessionID}/startrate1add`,
          data: {
            "carrierId": carData.carrier_id,
          },
        };
        await patchData.patchApi(requestParams).then((response) => {

        }).catch((error) => {
        });
        // trigger RC2 call for coverage submit in case of Branch 
        // const finalNavData = this.$store.getters.finalNavData;
        for (var index = 0; index < finalNavData.length; index++) {
          if (finalNavData[index].status === 'InactiveIncomplete' && finalNavData[index].name !== "hopolicydetails") {
            routeToErrorPage = finalNavData[index].name;
            pageNoError = false;
            break;
          }
        }

        //Running RC2--> RC3 bind logic here
        if (pageNoError) {
          await fetchData.getDashboard(`/quotes/${sessionID}/rc2`)
            .then((response) => {
              // do rc2 response check. If errors then display error and keep user on same page. 
              if (this.validateRc2Response(response)) {
                // do all success stuff here
              } else {
                return false;
                // do all fail stuff here 
              }

            });
          //this.$router.replace(common.getRouteName(`/Property/${continueButtonRouteTo}/tp`));
          //   this.$store.dispatch('sethomeRc2Nav', continueButtonRouteTo);
        }
      }
      if (continueButtonRouteLabel.includes("Checkout")) {
        console.log('in check out');
        // const finalNavData = this.$store.getters.finalNavData;
        for (var index = 0; index < finalNavData.length; index++) {
          if (finalNavData[index].status === 'InactiveIncomplete' || finalNavData[index].status === 'InactiveFirstTime') {
            if (apiErrors) {
              const filterApiPageSection = navsArr.filter(el => el.sections.includes(pageSectionApiError));
              if (filterApiPageSection[0].page_name === finalNavData[index].name) {
                routeToErrorPage = finalNavData[index].name;
                pageNoError = false;
                break;
              }
            }
            if (jsErrors) {
              const filterjsErrors = navsArr.filter(el => el.sections.includes(pageSectionjsErrors));
              if (filterjsErrors[0].page_name === finalNavData[index].name) {
                routeToErrorPage = finalNavData[index].name;
                this.$store.dispatch('setErrorPageAction', finalNavData[index].name);
                pageNoError = false;
                break;
              }
            }
          }
        }
        console.log('in check out', pageNoError, finalNavData, continueButtonRouteTo);
        // set RC2 error status to default 
        this.$store.dispatch('setRC2HomeError', false);
        this.$store.dispatch('setRC2HomeErrorDesc', "");
        //Running RC2--> RC3 bind logic here
        if (pageNoError) {
          await fetchData.getDashboard(`/quotes/${sessionID}/rc2`)
            .then((response) => {
              finalresponseStatus = true;

              // if (this.validateRc2Response(response)) {
              //   // do all success stuff here
              //   this.$router.replace(common.getRouteName(`/Property/${continueButtonRouteTo}/tp`));
              //   this.$store.dispatch('sethomeRc2Nav', continueButtonRouteTo);
              // } else {
              //   return false;
              //   // do all fail stuff here 
              // }
              //Commented aboved RC2 response check from xml  as Nationwide does not need this check
              
              this.$store.dispatch('sethomeRc2Nav', continueButtonRouteTo);
              if (submitFrom === 'bundle' || submitFrom === 'endtoend') {
                // let homeCarrier = sessionStorage.getItem('selectedCarrierHome').carrier_name;
                this.$router.push('/auto/bundle/checkout');
              } else if (submitFrom !== 'auto') {
                this.$router.replace(common.getRouteName(`/Property/${continueButtonRouteTo}/tp`));
              }
            });
        } else {
          if (submitFrom !== 'auto') {//TODO: Handle case for bundle
            this.$router.replace(common.getRouteName(`/Property/${routeToErrorPage}/tp`));
            this.$store.dispatch('sethomeRc2Nav', routeToErrorPage);
          }
        }
      } else {
        if (submitFrom !== 'auto') {//TODO: Handle case for bundle
          this.$router.replace(common.getRouteName(`/Property/${continueButtonRouteTo}/tp`));
          this.$store.dispatch('sethomeRc2Nav', continueButtonRouteTo);
          sessionStorage.setItem('sethomeRc2Nav', continueButtonRouteTo);
        }
      }
      if (submitFrom !== 'auto') {//TODO: Handle case for bundle
        this.$store.dispatch('setCurrentNav', getUrl);
        this.$store.dispatch('setRc2NavFlowAction', true);
      }
      return finalresponseStatus;
    },
    /*ending  rc2 home submit code*/ 
    submitted() {
      // runs VGS submissions to tokenize PCI data before running mainSubmit()
       if (this.vgsForm) {
        this.vgsSubmit();
       } else {
        this.mainSubmit();
       }
      // this.mainSubmit();
    },
    propertyRc3submitted(){
      if (this.vgsForm) {
       this.vgsSubmitProperty();
       console.log('vgs submit');
       } else {
        console.log('main submit');
       }
    },
    rc2Logo() {
      const element = this.pageData.blurbs.find(el => el.location === 'carrierlogo');
      if (element) {
        this.$store.dispatch('setRc2LogoURL', element.content);
      }
      const elementWhite = this.pageData.blurbs.find(el => el.location === 'headerlogo');
      if (elementWhite) {
        this.$store.dispatch('setRc2LogoURLWhite', elementWhite.content);
      }
    },
    setPolicyStatus(pagedataArr){
      let rc2sect = ['Missing Driver\'s License Number','Branch Quote Update | Confirm the following with the customer:','Reporting Consent '];
      let policystatus=true;
      for (let eCnt = 0; eCnt < pagedataArr.fields.length; eCnt++) { 
        if(!rc2sect.includes(pagedataArr.fields[eCnt].section) && ((pagedataArr.fields[eCnt].field_value==='' &&
        pagedataArr.fields[eCnt].is_required &&
        pagedataArr.fields[eCnt].visible) || (pagedataArr.fields[eCnt].has_error))){
           policystatus = false;
        }
      }
      sessionStorage.setItem('policystatus',policystatus);
    },    
    endToEndSubmitted() {
      if (this.$router.currentRoute.path === '/home/non-end-to-end' || this.$router.currentRoute.path === '/condo/non-end-to-end' || this.$router.currentRoute.path === '/renters/non-end-to-end') {
        let autoCarrierType = this.$store.getters.getSelectedAutoCarrier != '' && this.$store.getters.getSelectedAutoCarrier !== null ? this.$store.getters.getSelectedAutoCarrier.carrier_type : sessionStorage.getItem('selectedCarrierAuto') ? JSON.parse(sessionStorage.getItem('selectedCarrierAuto')).carrier_type : '';
        if (autoCarrierType === 'EZLYNXCARRIER') {
          sessionStorage.setItem('sessionData', sessionStorage.getItem('autoSessionData')); 
          this.$store.dispatch('setSessionQuote', { SessionId: JSON.parse(sessionStorage.getItem('autoSessionData')).SessionId });
          this.$router.replace('/auto/non-end-to-end');
        } else {
          //TODO checking from session storage as home coverage is getting reload and store is getting clear
          let AUQuoteId = JSON.parse(sessionStorage.getItem('autoSessionData')).SessionId;
          let currentNav = JSON.parse(sessionStorage.getItem('autoRC1BindResponse')).Navigate;
          this.$store.dispatch('setCurrentNav', currentNav);
          this.$store.dispatch('setSessionQuote', { SessionId: AUQuoteId });
          //change session data in storage
          sessionStorage.setItem('sessionData', sessionStorage.getItem('autoSessionData'));            
          this.$router.replace(common.getRouteName(currentNav)); 
        } 
      } else {
        // const continueButtonRouteTo = this.$store.getters.continueButtonData[0].routeTo;
        // const continueButtonRouteLabel = this.$store.getters.continueButtonData[0].label;
        // const carData = JSON.parse(sessionStorage.getItem("selectedCarrierHome"));
        if (sessionStorage.getItem('homebound') == 'true') {
          this.$router.push('/auto/bundle/checkout');
        } else {
          let homeRC2Errors = JSON.parse(sessionStorage.getItem('homeRC2Errors'));
          let submitFrom = 'endtoend';
          let HOQuoteId = JSON.parse(sessionStorage.getItem('homeSessionData')).SessionId;
          this.propertyBindsubmitted(homeRC2Errors, submitFrom, HOQuoteId);
        }
      }
    },
    async createPropRc2Tabs(RC1Tabs) {
      let inFields;
      let rc1Nav = {};
      const tabButtonDataConfig = JSON.parse(JSON.stringify(tabButtonConfigFromFile));
      const tabButtonData = { ...tabButtonDataConfig };
      let getUrl = `/pages/HORateCall2Details/${this.$store.getters.getSessionID}`;
      await axios.get(getUrl)
        .then((response) => {
          inFields = response.data.fields;
          const getNavFromStore = this.$store.getters.rc2Navigation;
          let distinctSections = [...new Set(inFields.map(el => el.section))];
          let neededNavigations = [];
          distinctSections.forEach(section => {
            const found = getNavFromStore.navs.filter(el => el.sections.includes(section));
            neededNavigations.push(found[0]);
          });
          let pageNamesForNeededNavigations = [...new Set(neededNavigations.filter(el => el !== undefined).map(el => el.page_name))];
          let rc2NavToCreate = tabButtonData['rc2Tabs'].filter(el => pageNamesForNeededNavigations.includes(el.name));
          rc1Nav = JSON.parse(RC1Tabs);
          const merge = (a1, a2) => {
            return a1.map((x) => {
              const y = a2.find(item => x.name === item.name);
              if (y) {
                return Object.assign({}, x, y);
              } else
                return x
            }).concat(a2.filter(item => a1.every(x => x.name !== item.name)));
          }
          let rc3Nav = merge(rc2NavToCreate, tabButtonData['rc3Tabs']);
          rc3Nav.forEach(element => {
            element.status = 'InactiveComplete'
          });
          this.navigationData = merge(rc1Nav, rc3Nav);
          sessionStorage.setItem('setfinalNavDataAction', JSON.stringify(this.navigationData));
          this.$store.dispatch('setfinalNavDataAction', this.navigationData);
        }).catch((error) => {
          window.console.warn('An error occurred while requesting RC2 API .', error);
        });
      return this.navigationData;
    },    
    /**
     * THis fucntion is used to send/download PDF
     */
    exportPDFTo(exportType, carrierDetailsArray,quoteStatus) {
      let quoteId = sessionStorage.getItem('sessionData') ? JSON.parse(sessionStorage.getItem('sessionData')).SessionId : '';
      if (exportType === 'printpdf') {
        let url = `quotes/${quoteId}/${quoteStatus}/PDF`;
        //email pdf functionality
        const requestParams = {
          url: url,
          data: carrierDetailsArray,
        };
        postData.generatePDF(requestParams).then((response) => {
          if (response) {
              const content = response.headers['content-type'];
              let currentTimeStamp = moment(new Date()).format('MMDDYYYY');
              let pdf_name = 'QRP Agent Portal - Quotes Summary ' + currentTimeStamp;
              download(response.data, pdf_name, content)           
          }
        });
      } else {
        //pdf email send functionality
      }
      return '';
    },
    updateQuoteSummaryStatus() {
      // this.$store.dispatch('quoteSummaryStatusToggle');
      // check if form container has fix top
      // this.@store.
      const formContainer = document.getElementById('form-container'); // TODO: Set once
      if (formContainer && formContainer.classList.contains('fixed-top') && this.$store.getters.getQuoteSummaryStatus) {
        formContainer.classList.add('quote-panel-scroll');
      } else if (!this.$store.getters.getQuoteSummaryStatus) {
        formContainer.classList.remove('quote-panel-scroll');
      }
    },
  },
  created() {
    // trigger quote summary modal
    const currentActionName = sessionStorage.getItem('currentActionName');
    const quoteSummaryStatus = sessionStorage.getItem('quoteSummaryStatus');
    if (currentActionName !== 'CreateQuote' && quoteSummaryStatus === 'visible') {
      this.$store.state.commonState.showQuoteSummaryStatus = true;
      this.updateQuoteSummaryStatus();
    
    }
    this.startTime = (new Date()).getTime();
    this.$store.state.first_error = null; // Reset pointer to this view's first error

    window.scroll(0, 0);

    this.collapsed_elements = this.get_collapsed_elements_list(); // TODO: Only fetch this once
  },
  mounted() {},
  watch: {
    pageData: function () {
      if (this.pageData &&
      this.pageData.quote_summary) {
        this.$nextTick(() => {
          this.$root.$emit('epic-enabled-header', this.pageData.quote_summary.is_created_in_qrp_for_epic);
          this.$root.$emit('export-enabled-header', this.pageData.quote_summary.is_exportable_to_epic);
        })
      }; 
    },
  },
  beforeDestroy() {
    let flowType = sessionStorage.getItem('flowType');
    /** Save data before navigating user to different section like search/dashboard/logout */
    //TODO: added bundle check as temporary fix for FSP-27758(500 error)
    if (this.$store.state.commonState.isUserNavigation && (flowType !== 'bundle' && flowType !== 'rabundle' && flowType !== 'cabundle')) {
      /*
       * set page load start time in store
       */
      this.$store.dispatch('setStartTime');
      const currentNavLink = this.pageData.tab_buttons[0].on_click;
      const formData = common.getFormData(this.pageData);
      const requestParams = {
        url: currentNavLink,
        data: formData,
      };
      postData.navigationFormPost(requestParams).then((response) => {
        if (response.data.Navigate) {
          this.$store.dispatch('setUserNavFlag', false);
        }
      });
    }
  }
};


// WEBPACK FOOTER //
// ./src/mixins/pageMixin.js